<div class="basic-info-container" id="basic-info-container">
  <form [formGroup]="reactiveForm" style="display: flex; flex-direction: column">
    <!-- <div class="title">
      <h4>{{isPackage ? 'Package Address' : 'Project Addresspe'}}</h4>
      <p style="margin-bottom: 0">Choose an address by searching in the input box below. It will fill out all the
        address fields for you.</p>
    </div> -->
    <app-auto-complete (setAddress)="getAddress($event)" addressType="geocode" [style]="style" class="pd_container">
    </app-auto-complete>
    <p *ngIf="isSubmitted && !reactiveForm.get('area').value" style="color: #f44336; margin-bottom: 0"
       class="pd_container mat-error">
      Please choose an address
    </p>
    <div class="fz_16 mt_30 pd_container" style="color: rgba(222, 222, 222, 0.4);">If your exact street address did not
      appear, enter
      it
      below (optional)
    </div>

    <mat-form-field appearance="outline" style="width: 45%" class="mt_20 pd_container">
      <mat-label>Address Line</mat-label>
      <input matInput type="text" formControlName="addressLine1">
    </mat-form-field>

    <div class="fc_DEDEDE fz_16 mt_20 pb_40"
         style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
      You will
      proceed
      with the address:
      <span *ngIf="reactiveForm.get('addressLine1').value">
        {{reactiveForm.get('addressLine1').value}}, {{this.reactiveForm.get('area').value}},
        <span *ngIf="reactiveForm.get('city').value.length > 0">
          {{this.reactiveForm.get('city').value }},
        </span>
         <span *ngIf="reactiveForm.get('city').value.length === 0">
        </span>
        {{this.reactiveForm.get("state").value }},
        <span> {{ this.reactiveForm.get("postCode").value }}</span>
      </span>
    </div>
    <!-- <div style="display: flex; justify-content: space-between; margin-top: 40px;">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Address Line</mat-label>
        <input matInput type="text" formControlName="addressLine1">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Suburb</mat-label>
        <input matInput type="text" formControlName="area" required>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>City</mat-label>
        <input matInput type="text" formControlName="city" required>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Postcode</mat-label>
        <input matInput type="text" formControlName="postCode" required>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>State</mat-label>
        <input matInput type="text" formControlName="state" required>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Country</mat-label>
        <input matInput type="text" formControlName="country" required />
      </mat-form-field>

    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Latitude</mat-label>
        <input matInput type="text" formControlName="lat" required>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Longitude</mat-label>
        <input matInput type="text" formControlName="lng" required>
      </mat-form-field>
    </div> -->
    <div class="title pt_40" style="margin-bottom: 0;padding: 40px 32px 0 32px;">
      <h4 class=" fz_21 fc_DEDEDE">Project Details</h4>
    </div>

    <div class="fc_DEDEDE fz_16 mt_20 pd_container">{{isPackage ? 'Package Type' : 'Project Type'}}</div>

    <mat-radio-group aria-label="Select an option" class=" mt_20 pd_container" formControlName="ptype" required>
      <mat-radio-button value="1" *ngIf="!isPackage">House</mat-radio-button>
      <mat-radio-button value="2" *ngIf="!isPackage">Townhouse</mat-radio-button>
      <mat-radio-button value="3" *ngIf="!isPackage">Apartment</mat-radio-button>
      <mat-radio-button value="4" *ngIf="!isPackage">Land</mat-radio-button>
      <mat-radio-button value="5" *ngIf="isPackage">Package (House)</mat-radio-button>
      <mat-radio-button value="6" *ngIf="isPackage">Package (Townhouse)</mat-radio-button>
      <mat-radio-button value="7" *ngIf="isPackage">Package (Apartment)</mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="ptypeShow" style="margin-left: 32px;">{{isPackage ? 'Package Type' : 'Project Type'}} required
    </mat-error>


    <div class="fc_DEDEDE fz_16 mt_10 pd_container">{{isPackage ? 'Package Status' : 'Construction Status'}}</div>
    <mat-radio-group aria-label="Select an option" class=" mt_20 pd_container" formControlName="pstatus" required>
      <mat-radio-button *ngFor="let status of projectStatus" [value]="status.value"> {{status.name}}
      </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="pstatusShow" style="margin-left: 32px;">{{isPackage ? 'Package Status' : 'Project Status'}}
      required
    </mat-error>
    <mat-form-field appearance="outline" class="mt_30 pd_container">


      <mat-label>{{isPackage ? 'Package Name' : 'Project Name'}}</mat-label>
      <input matInput formControlName="pname" placeholder="" required>

    </mat-form-field>
    <!-- <mat-error class="fz_16 pd_container" *ngIf="pnameShow">required</mat-error> -->

    <mat-form-field appearance="outline" class="mt_30 pd_container">
      <mat-label>Website</mat-label>
      <input matInput formControlName="website">
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt_30 pd_container">
      <mat-label>3D Showroom Link</mat-label>
      <input matInput formControlName="vrURLs">
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt_30 pd_container">
      <mat-label>Video Link</mat-label>
      <input matInput formControlName="videoURL">
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt_30 pd_container mat-focused mat-form-field-should-float">
      <mat-label>{{this.reactiveForm.get('ptype').value == '4' ? 'Total land lots' : 'Total unit'}}</mat-label>
      <input matInput formControlName="totalUnit" type="number"
             onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
             placeholder="How many Units?">
    </mat-form-field>


    <div class=" flex justify-between align-center mt_30 pd_container">
      <mat-form-field appearance="outline" style="width: 40%" class="mat-focused mat-form-field-should-float">
        <mat-label>Min Price</mat-label>
        <input matInput formControlName="minPrice" type="number"
               onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
               placeholder="Please select">
        <mat-error *ngIf="reactiveForm.get('minPrice').invalid">required</mat-error>
      </mat-form-field>
      <div style="width: 52px;height:2px;background:#DEDEDE;margin-bottom: 25px;"></div>
      <mat-form-field appearance="outline" style="width: 40%" class="mat-focused mat-form-field-should-float">
        <mat-label>Max Price</mat-label>
        <input matInput formControlName="maxPrice" type="number"
               onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
               placeholder="Please select">
        <mat-error *ngIf="reactiveForm.hasError('priceMismatch')">Max Number has to greater than Min Number</mat-error>
      </mat-form-field>
    </div>

    <div class="flex justify-between align-center mt_30 pd_container"
         style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
      <mat-form-field appearance="outline" style="width: 40%" class="mat-focused mat-form-field-should-float">
        <mat-label>Min Total Area (acres)</mat-label>

        <input matInput formControlName="minTotalArea" type="number"
               onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
               placeholder="Please select">
      </mat-form-field>
      <div style="width: 52px;height:2px;background:#DEDEDE;margin-bottom: 25px;"></div>
      <mat-form-field appearance="outline" style="width: 40%" class="mat-focused mat-form-field-should-float">
        <mat-label>Max Total Area (acres)</mat-label>
        <input matInput formControlName="maxTotalArea" type="number"
               onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
               placeholder="Please select">

        <mat-error *ngIf="reactiveForm.invalid">Max Total Area has to greater than Min Total Area</mat-error>
      </mat-form-field>
    </div>

    <div class="fc_DEDEDE fz_16 pd_container mb_50"></div>
    <div fxLayout="row" fxLayoutGap="20px" class=""
         style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
      <div fxFlex="50">
        <div class="fc_DEDEDE fz_16 mt_40  mb_50">Bedrooms</div>
        <div class="flex justify-between align-center mt_30 ">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Min Bedrooms</mat-label>
            <!-- <input matInput formControlName="minBedRoom" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
            <mat-select formControlName="minBedRoom">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Max Bedrooms</mat-label>
            <mat-select formControlName="maxBedRoom">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
            <!-- <input matInput formControlName="maxBedRoom" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
            <mat-error *ngIf="reactiveForm.invalid">Max Bedrooms has to greater than Min Bedrooms</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxFlex="50">
        <div class="fc_DEDEDE fz_16 mt_40  mb_50">Bathrooms</div>

        <div class="flex justify-between align-center mt_30 pr_20">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Min Bathrooms</mat-label>
            <mat-select formControlName="minBathRoom">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
            <!-- <input matInput formControlName="minBathRoom" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Max Bathrooms</mat-label>
            <mat-select formControlName="maxBathRoom">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
            <!-- <input matInput formControlName="maxBathRoom" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
            <mat-error *ngIf="reactiveForm.invalid">Max Bathrooms has to greater than Min Bathrooms</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="fc_DEDEDE fz_16 mt_40 pd_container mb_50">Car Spaces and Extra Information</div>

    <div fxLayout="row" fxLayoutGap="20px" class="pd_container">
      <div fxFlex="50">
        <div class="flex justify-between align-center mt_30 ">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Min Car Spaces</mat-label>
            <mat-select formControlName="minParking">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
            <!-- <input matInput formControlName="minParking" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Max Car Spaces</mat-label>
            <mat-select formControlName="maxParking">
              <mat-option value="%" *ngFor="let price of priceType" [value]="price.value">{{price.name}}</mat-option>
            </mat-select>
            <!-- <input matInput formControlName="maxParking" type="number"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"> -->
            <mat-error *ngIf="reactiveForm.invalid">Max Car Spaces has to greater than Min Car Spaces</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxFlex="50">
        <mat-form-field appearance="outline" class=" mt_30" style="width: -webkit-fill-available">
          <mat-label>Level</mat-label>
          <input matInput formControlName="level" type="number"
                 onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0">
        </mat-form-field>
      </div>
    </div>

    <div class="fc_DEDEDE fz_16 mt_20 pd_container mat-error"
         [ngClass]="{'firb-required': reactiveForm.get('firb').invalid && isSubmitted}">FIRB
    </div>
    <mat-radio-group aria-label="Select an option" class=" mt_20 " formControlName="firb" required
                     style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
      <mat-radio-button [value]=1 style="margin-right: 40px">
        Yes
      </mat-radio-button>
      <mat-radio-button [value]=0>
        No
      </mat-radio-button>
    </mat-radio-group>
    <ng-container *ngIf="reactiveForm.get('ptype').value != '4'">
      <div class="fc_DEDEDE fz_16 mt_40  mb_50 pd_container">Buildings</div>
      <div formArrayName="buildings" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start center"
           class="pd_container mt_30 building_box"
           style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
        <mat-form-field *ngFor="let building of buildings.controls; let i=index" appearance="outline"
                        [formGroupName]="i">
          <div class=" flex align-center">
            <div class="pr_10" style="color: #dedede;border-right: 1px solid #dedede;">{{i + 1}}</div>
            <input matInput formControlName="name" required style="margin-left: 10px;">
          </div>
          <img src="./assets/images/black/delete.png" class="delete_image" (click)="removeBuilding(i)" *ngIf="i>0">
        </mat-form-field>

        <!-- <mat-form-field *ngFor="let building of buildings.controls; let i=index" appearance="outline" style="width: 15%"
          [formGroupName]="i">
          <mat-label>Building {{i+1}}</mat-label>

          <img src="./assets/images/black/delete.png" class="delete_image" (click)="removeBuilding(i)" *ngIf="i>0">

        </mat-form-field> -->
        <button (click)="addBuilding()" type="button" mat-button class="add_button">
          Add building
        </button>
      </div>
    </ng-container>

    <!-- <div style="display: flex; justify-content: space-between">

      <div style="display: flex; justify-content: space-between; width: 45%">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Commission</mat-label>
          <input matInput formControlName="commission">
          <mat-error *ngIf="reactiveForm.invalid">Value has to be a number.</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Commission unit</mat-label>
          <mat-select formControlName="commissionUnit">
            <mat-option value="%">%</mat-option>
            <mat-option value="AUD">AUD</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <!-- <mat-form-field appearance="outline" style="width: 45%;">
      <mat-label>Introduction (Simplified Chinese)</mat-label>
      <textarea matInput formControlName="introductionZH" style="height: 100px"></textarea>
      <mat-error *ngIf="reactiveForm.get('introductionZH').invalid">Cannot exceed 2000 characters</mat-error>
    </mat-form-field> -->
    <!-- <div *ngIf="reactiveForm.get('ptype').value == '4'">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>City Council</mat-label>
        <input matInput formControlName="cityCouncil">
      </mat-form-field>
    </div> -->


    <ng-container *ngIf="reactiveForm.get('ptype').value != '4'"
                  class="feature-group">
      <div class="fc_DEDEDE fz_16 mt_40 pd_container mb_50">Indoor features</div>
      <div fxLayout="row wrap" class="pd_container mt_30">
        <mat-checkbox *ngFor="let feature of indoorFeatures" [checked]="isCheckBoxSelected(feature.id)"
                      (change)="select($event, feature.id)">
          {{feature.notes.en}}
        </mat-checkbox>
      </div>
      <div class="clear cursor_pointer" (click)="handleClearIndoor()">Clear all</div>
      <div class="fc_DEDEDE fz_16 mt_40 pd_container">Outdoor features</div>
      <div fxLayout="row wrap" class="pd_container mt_40">
        <mat-checkbox *ngFor="let feature of outdoorFeatures" [checked]="isCheckBoxSelected(feature.id)"
                      (change)="select($event, feature.id)">
          {{feature.notes.en}}
        </mat-checkbox>
      </div>
      <div class="fc_DEDEDE fz_16 mt_40 pd_container">Energy features</div>
      <div fxLayout="row wrap" class="pd_container mt_40">
        <mat-checkbox *ngFor="let feature of energyFeatures" [checked]="isCheckBoxSelected(feature.id)"
                      (change)="select($event, feature.id)">
          {{feature.notes.en}}
        </mat-checkbox>
      </div>
      <div class="fc_DEDEDE fz_16 mt_40 pd_container">Public facility</div>
      <div fxLayout="row wrap" class=" mt_40" style=" padding: 0 32px 24px 32px;">
        <mat-checkbox *ngFor="let feature of publicFeatures" [checked]="isCheckBoxSelected(feature.id)"
                      (change)="select($event, feature.id)">
          {{feature.notes.en}}
        </mat-checkbox>
      </div>
      <div class="clear cursor_pointer" style="padding-bottom: 50px;" (click)="handleClearPublic()">Clear
        all
      </div>
      <div class="border-bottom"></div>
    </ng-container>
    <div>

      <!-- Description START -->
      <div
        class="form-container"
        fxLayout="column wrap">
        <div fxLayout="column wrap"
             fxLayoutAlign="center start"
             class="form-container__description">
          <div class="form-container__description-title">Description</div>
          <div class="form-container__description-text"
               fxLayout="row wrap">
            Use our new Generative AI Descriptor to automatically generate your project description.
            It combines your project details with the latest best performing project descriptions across the industry.
          </div>
        </div>
        <mat-form-field appearance="outline" class="pd_container">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="introductionEN" style="height: 100px"></textarea>
          <mat-error *ngIf="reactiveForm.get('introductionEN').invalid">Cannot exceed 2000 characters</mat-error>
        </mat-form-field>
        <div fxLayout="row wrap"
             fxLayoutAlign="end center"
             class="form-container__button-group">
          <button mat-stroked-button
                  class="form-container__button"
                  (click)="undo()">Undo
          </button>
          <button mat-stroked-button
                  class="form-container__button"
                  *ngIf="!isGenerating"
                  (click)="generateAIDescription()">Generate AI Description
          </button>
          <button mat-stroked-button
                  class="form-container__button loading"
                  *ngIf="isGenerating"
                  [disabled]="true">Generating...
          </button>
        </div>
      </div>
      <!-- Description END -->
      <div class="fc_DEDEDE fz_16 mt_40 pd_container mb_50">Key Dates</div>
      <div fxLayout="row" fxLayoutGap="40px" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" fxFlexAlign="start center"
           class=" mt_30" style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;">
        <mat-form-field color="accent" appearance="fill" style="width: 30%">
          <mat-label>Start Date (optional)</mat-label>
          <input matInput [matDatepicker]="picker1" (dateChange)="getStartDate($event)" disabled>
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 [disabled]="false"></mat-datepicker>

        </mat-form-field>
        <mat-form-field color="accent" appearance="fill" style="width: 30%">
          <mat-label>End Date (optional)</mat-label>
          <input formControlName="endDate" matInput [matDatepicker]="picker2" (dateChange)="getEndDate($event)"
                 disabled>
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 [disabled]="false"></mat-datepicker>
          <mat-error *ngIf="reactiveForm.get('endDate').invalid">End Date has to greater than Start Date</mat-error>

        </mat-form-field>
        <mat-form-field color="accent" appearance="fill" style="width: 30%">
          <mat-label>Sunset Date (optional)</mat-label>
          <input matInput [matDatepicker]="picker3" (dateChange)="getSunsetDate($event)" disabled>
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3 [disabled]="false"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="fc_DEDEDE fz_16 mt_40 pd_container mb_50">Incentives</div>
      <div style="display: flex; justify-content: space-between" class="pd_container mt_40">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Incentive 1 (optional)</mat-label>
          <input matInput formControlName="incentive1">
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Incentive 2 (optional)</mat-label>
          <input matInput formControlName="incentive2">
        </mat-form-field>
      </div>
      <div
        style="display: flex; justify-content: space-between;border-bottom: 0.5px solid rgba(222, 222, 222, 0.2); padding: 0 32px 40px 32px;"
        class=" mt_30">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Incentive 3 (optional)</mat-label>
          <input matInput formControlName="incentive3">
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Incentive 4 (optional)</mat-label>
          <input matInput formControlName="incentive4">
        </mat-form-field>
      </div>

    </div>
    <div style="padding: 32px;">
      <!--      <section class="notification">-->
      <!--        <mat-checkbox class="notification__checkbox"-->
      <!--        formControlName="sendAgentsEmails">-->
      <!--          Notify all Agents about this new listing-->
      <!--        </mat-checkbox>-->
      <!--      </section>-->
      <div class="notification"
           fxLayout="row"
           fxLayoutAlign="start start">
        <input type="checkbox"
               class="notification__checkbox"
               formControlName="sendAgentsEmails"
               fxFlex="2">
        <span class="notification__content"
              fxFlex="98">
          Recommend me Agents to invite to this project (Yephome will provide a list of suitable real estate agents
          you can discuss the project details about)
        </span>
      </div>
      <div fxLayout="row"
           fxLayoutAlign="end center"
           fxLayoutGap="2rem">
        <button mat-button [disabled]="isCreating === true" (click)="onSaveDraft()"
                [ngClass]="{'deactivated': isCreating === true, 'activated': isCreating === false}"
                class="create_button" style="width: 25%">
          Save Draft
        </button>
        <button mat-button [disabled]="isCreating === true" (click)="onSubmit()"
                [ngClass]="{'deactivated': isCreating === true, 'activated': isCreating === false}"
                class="create_button"
                style="width: 40%">
          Submit for Review
        </button>
      </div>
    </div>
  </form>
</div>
